import React from "react";
import { Passengers } from "../OrderDetail/Passengers";

function RenameConfirmationPassengers({ data }) {
  return (
    <div className="w-full">
      <Passengers
        title="New Passenger Info"
        noEdit
        order={{
          booking: {
            flightBooking: [
              data?.changedFlightBooking || {
                ...data?.flightBooking,
                travelers: data?.passengerInfo,
              },
            ],
          },
        }}
      />
      <Passengers
        title="Old Passenger Info"
        noEdit
        order={{ booking: { flightBooking: [data?.flightBooking] } }}
      />
    </div>
  );
}

export default RenameConfirmationPassengers;
